var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3963 0.778724L13.436 7.05642C13.6428 7.69282 14.2358 8.1237 14.905 8.1237L21.5058 8.1237L16.1656 12.0035C15.6243 12.3968 15.3977 13.094 15.6045 13.7304L17.6443 20.0081L12.3041 16.1283C11.7628 15.735 11.0297 15.735 10.4884 16.1283L5.14826 20.0081L7.188 13.7304C7.39478 13.094 7.16826 12.3968 6.6269 12.0035L1.28677 8.1237L7.88753 8.1237C8.55669 8.1237 9.14974 7.69282 9.35652 7.05642L11.3963 0.778724Z",
    fill: "#47FFBD",
    stroke: "#47FFBD",
    strokeWidth: 1.54458
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartGreen);
export default __webpack_public_path__ + "static/media/start-green.466cb68f526f8327e601f51501b12159.svg";
export { ForwardRef as ReactComponent };